// extracted by mini-css-extract-plugin
export default {"themeText":"var(--text)","reportLink":"ReportLink-module_reportLink__2ek0G","menuLogo":"ReportLink-module_menuLogo__2K4Iy"};